module.exports = __webpack_public_path__ + "img/Clarity-grouping2.b0749716.png";